import React from 'react';
import { AdoptsModalType } from './constants';
import BuyerModalLoadable from './modals/BuyerModalLoadable';
import SellerModalLoadable from './modals/SellerModalLoadable';
import TransactionHistoryModalLoadable from './modals/TransactionHistoryModalLoadable';
export const adoptsModalRenderer = (modalType, requestClose, params)=>{
    switch(modalType){
        case AdoptsModalType.BUYER_MODAL:
            return /*#__PURE__*/ React.createElement(BuyerModalLoadable, {
                onRequestClose: requestClose,
                deviation: params.deviation,
                initialScreen: params.initialScreen
            });
        case AdoptsModalType.SELLER_MODAL:
            return /*#__PURE__*/ React.createElement(SellerModalLoadable, {
                onRequestClose: requestClose,
                deviations: params.deviation ? [
                    params.deviation
                ] : params.deviations,
                initialScreen: params.initialScreen
            });
        case AdoptsModalType.TRANSACTION_HISTORY_MODAL:
            return /*#__PURE__*/ React.createElement(TransactionHistoryModalLoadable, {
                onRequestClose: requestClose,
                deviation: params.deviation
            });
        default:
            return null;
    }
};

//# sourceMappingURL=project-tools.js.map